module.exports = __webpack_public_path__ + "img/exam-result-tips.7623a0e3.webp";